var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivitiesFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09618 14.2734H11.1073V12.2734H4.09618V14.2734ZM14.112 14.2734H16.1152V4.27344H14.112V14.2734ZM4.09618 10.2734H11.1073V8.27344H4.09618V10.2734ZM4.09618 6.27344H11.1073V4.27344H4.09618V6.27344ZM2.09301 18.2734C1.54214 18.2734 1.07056 18.0776 0.678275 17.6859C0.285987 17.2943 0.0898438 16.8234 0.0898438 16.2734V2.27344C0.0898438 1.72344 0.285987 1.2526 0.678275 0.860938C1.07056 0.469271 1.54214 0.273438 2.09301 0.273438H18.1184C18.6692 0.273438 19.1408 0.469271 19.5331 0.860938C19.9254 1.2526 20.1215 1.72344 20.1215 2.27344V16.2734C20.1215 16.8234 19.9254 17.2943 19.5331 17.6859C19.1408 18.0776 18.6692 18.2734 18.1184 18.2734H2.09301ZM2.09301 16.2734H18.1184V2.27344H2.09301V16.2734Z",
    fill: "#C35700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiesFeed);
export default __webpack_public_path__ + "static/media/activities-feed.89a02d556c864f61d49b84fb6ff1db90.svg";
export { ForwardRef as ReactComponent };